module.exports = __webpack_public_path__ + "img/ludi nord 2024.60dedb81.webp";